import { render, staticRenderFns } from "./MetricsReport.vue?vue&type=template&id=d79ef474"
import script from "./MetricsReport.vue?vue&type=script&lang=js"
export * from "./MetricsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports